import type { AppVersionPolicy } from "~/services/common/appVersion";

interface ForceUpdateScreenProps {
  policy: AppVersionPolicy;
  force: boolean;
  onUpdate: () => void;
  onClose?: () => void;
}

export const ForceUpdateScreen = ({
  policy,
  force,
  onUpdate,
  onClose,
}: ForceUpdateScreenProps) => {
  const title = policy.title || (force ? "앱 업데이트가 필요해요" : "새 버전이 있어요");
  const message = policy.message
    || (force
      ? "안정적인 서비스 이용을 위해 최신 버전으로 업데이트해 주세요."
      : "최신 버전으로 업데이트하면 더 안정적으로 이용할 수 있어요.");

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-[#F5F5F5] px-6">
      {!force && onClose && (
        <button
          type="button"
          aria-label="닫기"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white text-sm font-semibold text-[#555] shadow-sm"
        >
          닫기
        </button>
      )}

      <section className="w-full max-w-[360px] rounded-2xl bg-white px-6 py-8 text-center shadow-[0_18px_40px_-24px_rgba(0,0,0,0.35)]">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#FF7A00]/10 text-sm font-bold text-[#FF7A00]">
          UP
        </div>

        <h1 className="text-xl font-bold leading-tight text-[#1D1D1D]">
          {title}
        </h1>
        <p className="mt-3 whitespace-pre-line text-sm leading-6 text-[#666]">
          {message}
        </p>

        <button
          type="button"
          onClick={onUpdate}
          className="mt-7 h-12 w-full rounded-xl bg-[#FF7A00] text-base font-semibold text-white shadow-[0_10px_18px_-12px_rgba(255,122,0,0.9)]"
        >
          업데이트하기
        </button>
      </section>
    </div>
  );
};
